import React, {PureComponent} from 'react';

import {Button, Classes, MenuItem, Overlay, Callout} from "@blueprintjs/core";
import {Select} from "@blueprintjs/select";
import http from "../../services/httpService";
import {default as authService} from "../../services/authService";
import toastr from "toastr";


export default class CustomizeShortLinkModal extends PureComponent {
    state = {
        overlayIsOpen: false,
        selectedDomain: this.props.selectedDomain,
        oldShortCode: '',
        shortCode: this.props.shortCode,
        domains: ['https://oo.fyi/t/', 'https://s.emitto.io/t/'],
        error: false,
        loading: false,
        firstOpen: true

    }
    handleClose = () => {
        this.setState({
            overlayIsOpen: false
        })
    }

    componentDidMount() {
        this.setState({
            oldShortCode: this.props.oldShortCode,
            overlayIsOpen: this.props.showModal
        })
    }

    componentDidUpdate = async () => {
        if (this.state.overlayIsOpen !== this.props.showModal) {
            this.setState({
                oldShortCode: this.props.oldShortCode,
                overlayIsOpen: this.props.showModal,
            })
        }
        if (this.state.shortCode !== this.props.shortCode && this.state.firstOpen === true) {
            //console.log('shortCodeChanged');
            //console.log('shortCode :', this.props.shortCode);

            await this.setState({
                shortCode: this.props.shortCode,
                firstOpen: !this.props.shortCode
            })
        }
    }


    handleShortCode = (shortCode) => {
        // console.log('newValue: ', shortCode)
        this.setState({shortCode: shortCode})
    }
    domainRender = (item, {modifiers, handleClick}) => {

        return (

            <MenuItem
                key={item}
                text={item}
                value={item}
                active={modifiers.active}
                shouldDismissPopover={true}
                onClick={handleClick}
            />
        )
    };


    domainItemSelect = (item) => {
        this.setState({selectedDomain: item})
    }

    checkCode = async () => {
        await this.setState({
            loading: true
        });

        let data = {
            code: this.state.shortCode
        };

        try {
            const result = await http.post("https://oo.fyi/code-check", data, {
                headers: {
                    authorization: authService.getJwt()
                }
            });

            //console.log('code result: ', result);

            if (result.data.body.message === "No short url with that code exists.") {
                this.setState({error: false})
                this.props.saveShortCode(this.state.oldShortCode, this.state.shortCode, this.state.selectedDomain)
            } else {
                this.setState({error: true})
            }


        } catch (e) {
            await this.setState({
                loading: false
            });
            toastr.error('Error Code #21012: ' + e);
        }
        await this.setState({
            loading: false
        })
    };

    render() {
        return (
            <Overlay
                onClose={this.props.handleClose}
                className={Classes.OVERLAY_SCROLL_CONTAINER + ' customize-short-link-modal'}
                isOpen={this.state.overlayIsOpen}

                style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <div className="modal-field"
                     style={{width: this.props.width || '60%', maxWidth: this.props.maxWidth || '100%'}}>

                    <div className="modal-header">
                        <h2>Customize Short Link</h2>
                        <span className='close-modal' onClick={() => {
                            this.props.handleClose()
                        }}>×</span>
                    </div>
                    <div className="onboarding-panel viber-modal-container">


                        <Callout
                            className='customize-shortlink-dropdown'
                        >
                            Customizing the short URL will make the old link non-functional.
                        </Callout>

                        <p className="full-row-label">Short Link</p>
                        <div className="display-flex">
                            <Select
                                items={this.state.domains}
                                itemRenderer={this.domainRender}
                                onItemSelect={this.domainItemSelect}
                                filterable={false}
                                className='sendersSelector'
                            >
                                <Button text={this.state.selectedDomain} rightIcon='caret-down'/>
                            </Select>
                            <input
                                style={{flex: 1, height: 40}}
                                className=""

                                value={this.state.shortCode.replace('t/', '')}
                                placeholder={''}
                                onChange={(e) => this.handleShortCode(e.target.value)}
                            />
                        </div>
                        {this.state.error ?
                            <Callout
                                intent={'danger'}
                            >Please try again, it looks like this name already exists.</Callout>
                            :
                            ''
                        }
                        <div className="shortener-buttons m-m-t">
                            <button
                                className="btn-lite dist-platf-button"
                                disabled={false}
                                onClick={() => {
                                    this.props.handleClose()
                                }}>
                                Cancel
                            </button>
                            <button
                                className="btn-action dist-platf-button"
                                disabled={this.state.loading ? true : ''}
                                onClick={this.checkCode}>
                                Save
                                {
                                    this.state.loading ?
                                        <i className='fa fa-spin fa-spinner'></i>
                                        :
                                        ""
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </Overlay>
        )
    }
}